module.exports = __webpack_public_path__ + "static/img/1718087315347.80a82a11.jpg";